import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalComponent } from '../base-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClassifierValueCard } from 'types/classifier.interface';
import { SpinnerComponent } from 'components/spinner/spinner.component';

@Component({
  selector: 'app-delete-classifier-value',
  standalone: true,
  imports: [TranslateModule, SpinnerComponent],
  templateUrl: './delete-classifier-value.component.html',
  styleUrl: './delete-classifier-value.component.scss'
})
export class DeleteClassifierValueComponent extends BaseModalComponent {
  @Input() value!: ClassifierValueCard;
  @Output() save: EventEmitter<string> = new EventEmitter<string>();

  constructor(config: NgbModalConfig, modalService: NgbModal) {
    super(config, modalService);
  }

  handleSave() {
    this.save.emit(this.value.id);
  }
}
